/**
 * 正在这一段上怎么说（巡检 R9-10 补：坐出租车时写“出租车 · 正在走”，“正在走”只适合步行）。
 * 步行“正在走”；坐车（出租车、自驾、公共交通、火车）“在车上”；坐船“在船上”；坐飞机“在飞机上”；
 * 契约以后加了别的交通方式就说“在路上”，不猜是车是船。走过了 / 接下来两种说法不分交通方式，照旧。
 *
 * 地图“这趟旅途”面板（world_map/TripSheet.tsx）和旅途页（journey/JourneyPage.tsx）的路线列表共用这一份
 * （2026-09-25 从 TripSheet 挪来；只许有这一处定义，tests/claude-6c2b-journey-fixes.test.tsx 有源码检查）。
 */
export function currentLegText(mode: string): string {
  switch (mode) {
    case "walk":
      return "正在走";
    case "taxi":
    case "drive":
    case "transit":
    case "train":
      return "在车上";
    case "ferry":
      return "在船上";
    case "flight":
      return "在飞机上";
    default:
      return "在路上";
  }
}
